import React from "react";
import { HttpNoData, HttpData } from "../Core";

export async function getExtraWorkCategories(jwt) {
  const response = await HttpNoData("/api/v0/extraWorkCategories", "GET", jwt);

  if (!response.statusSuccessful) console.log(response.error);

  return response.data;
}

export async function putExtraWorkInCategory(id, extraWorkId, jwt) {
  const response = await HttpNoData(
    `/api/v0/extraWorkCategories/${id}/${extraWorkId}`,
    "PUT",
    jwt
  );

  if (!response.statusSuccessful) console.log(response.error);

  return response.statusSuccessful;
}

export async function createExtraWorkCategory(jwt, name) {
  const response = await HttpData(`/api/v1/extraWorkCategories`, "POST", jwt, {
    name: name,
  });

  if (!response.statusSuccessful) console.log(response.error);

  return response.data;
}

export async function editExtraWorkCategory(id, jwt, name) {
  const response = await HttpData(`/api/v1/extraWorkCategories/${id}`, "PUT", jwt, {
    name: name,
  });
  return response.statusSuccessful;
}
